<template lang="pug">
div(v-if="!$vuetify.breakpoint.mobile")
  v-app-bar.white.elavation-0(app light height="72" :style="'box-shadow: 0 1px 1px 0 rgba(0,0,0,.08) !important; z-index: 12'")
    v-container(fluid :class="$vuetify.breakpoint.mobile ? 'px-0' : 'px-4'" style="max-width: 1600px")
      v-row(no-gutters align="center")
        v-col(cols="3" md="2" sm="2")
          v-icon $yzi-yezza-icon
        v-col(cols="6" md="8" sm="8")
          div.d-flex.align-center.justify-center
            v-menu(v-if="$vuetify.breakpoint.smAndDown")
              template(v-slot:activator="{ on }")
                div.text-center(v-on="on" style="width: 100%")
                  .px-4.py-2
                    a.text-sm.font-semibold.capitalize.no-underline.neutral700--text {{ $store.state.ui.currentNavbarTitle }}
                  .bar-active
              v-list(nav dense)
                v-list-item-group
                  template(v-for="(menuTab, index) in menuTabs")
                    v-list-item
                      v-list-item-title
                        router-link(:to="menuTab.to" v-slot="{ href, navigate }" custom :key="'menutab'+ index")
                          .font-semibold.text-md.px-3.py-2.mb-2(@click="navigate") {{ menuTab.title }}
            template(v-else)
              div(v-for="(menuTab, index) in menuTabs")
                router-link(:to="menuTab.to" v-slot="{ href, navigate }" custom :key="'menutab'+ index")
                  div
                    .px-4.py-2
                      a.text-sm.font-semibold.capitalize.no-underline(:href="href" @click="navigate" :class="isMenuActive(menuTab) ? '' : 'neutral500--text'") {{ menuTab.title }}
                    .bar-active(v-if="isMenuActive(menuTab)")
        v-col(cols="3" md="2" sm="2")
          div.d-flex.align-center.justify-end
            //- Display size
            v-menu(offset-y left attach rounded="lg")
              template(v-slot:activator="{ on }")
                v-btn.mr-4(outlined small height="32" color="neutral500" v-on="on")
                  v-icon(left size="18") mdi-monitor-screenshot
                  .text-xs.font-semibold.normal-case {{ getSizeText(selectedSize) }}
              v-list(dense)
                v-list-item-group(v-model="selectedSize")
                  v-list-item(v-for="size in sizes" :key="size.value" :value="size.value" :disabled="selectedSize === size.value")
                    v-list-item-content
                      v-list-item-title.text-sm.neutral700--text {{ size.text }}
            //- Account
            v-menu(offset-y left attach rounded="lg" min-width=200)
              template(v-slot:activator="{ on }")
                v-avatar.cursor-pointer(color="#F2F4F7" size=40 v-on="on")
                  v-icon(size=24 color="primary") $yzi-user-01
              v-list.text-sm.py-0
                v-list-item
                  .py-3
                    .text-sm.font-semibold {{ member.user.first_name }}
                    .text-sm.neutral500--text {{ isClinic ? getMemberRole(member.roles) : member.role }}
                v-divider.basic300
                v-list-item(@click="redirectTo('/admin/hq/settings/account')")
                  v-icon.mr-2(color="primary" size=16) $yzi-user-01
                  .text-sm.font-medium {{ $t('account_settings') }}


                v-divider.basic300
                v-list-item(:href="changeCompanyUrl()")
                  v-icon.mr-2(color="primary" size=16) mdi-swap-horizontal
                  .text-sm.font-medium Switch company

                v-divider.basic300
                v-list-item(@click="redirectTo('/admin/hq/patients')")
                  v-icon.mr-2(color="primary" size=16) $yzi-users-02
                  .text-sm.font-medium Patient records

                v-divider.basic300
                v-list-item(@click="redirectTo('/admin/hq/inventory/settings')")
                  v-icon.mr-2(color="primary" size=16) $yzi-settings-01
                  .text-sm.font-medium General settings

                v-divider.basic300
                v-list-item(:href="logoutUrl()")
                  v-icon.mr-2(color="primary" size=16) $yzi-log-out-01
                  .text-sm.font-medium {{ $t('log_out') }}

</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'AppTopBarHq',
  props: ['menu'],
  data: () => ({
    sizes: [
      { text: 'X-Large', value: 'x-large' },
      { text: 'Large', value: 'large' },
      { text: 'Medium', value: 'medium' },
      { text: 'Small', value: 'small' },
      { text: 'X-Small', value: 'x-small' },
      { text: 'XX-Small', value: 'xx-small' },
    ]
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('ui', ['hasNewFeature', 'currentTopBarItems']),
    ...mapState('subscriptions', ['genesData', 'isReady']),
    ...mapGetters({
      patientHistoryHeightAdjustment: 'ui/getConsultationPatientHistoryHeightAdjustment',
      treatmentTableHeightAdjustment: 'ui/getConsultationTreatmentTableHeightAdjustment',
      visitNoteHeightAdjustment: 'ui/getConsultationVisitNoteHeightAdjustment',
      displaySize: 'ui/getDisplaySize',
      company: 'getCompany'
    }),
    menuTabs () {
      return this.hqNavbar()
    },
    isClinic () {
      return this.genesData?.find(g => g.feature === 'YZ_CLINIC' || g.feature === 'YZ_CMS')
    },
    selectedSize: {
      get () {
        return this.displaySize
      },
      set (val) {
        if (val) {
          this.$store.commit('ui/setDisplaySize', val)
        }
      }
    },
  },
  created () {
    this.getScrollbarWidth()
  },
  methods: {
    hqNavbar () {
      const menu = []
      menu.push({id: 'insight', to: '/admin/hq/insights', title: this.$t('insights')})
      menu.push({id: 'inventory', to: '/admin/hq/inventory', title: this.$t('inventory')})
      // TODO: Re-enable HQ Purchase Hub nav tab when feature is ready
      // menu.push({id: 'purchase-hub', to: '/admin/hq/purchase-hub', title: 'Purchase Hub'})
      menu.push({id: 'bookings', to: '/admin/hq/bookings', title: this.$t('bookings')})
      return menu
    },
    getMemberRole (roles) {
      if (roles.length > 2) {
        return `${this.getClinicRole(roles[0])} and ${roles.length - 1} more`
      } else if (roles.length > 1) {
        return roles.map(m => this.getClinicRole(m)).join(', ')
      } else {
        return this.getClinicRole(roles[0])
      }
    },
    getClinicRole (role) {
      switch (role) {
        case 'Admin':
          return 'Admin'
        case 'Salesperson':
          return 'Clinic Assistance'
        case 'Agent':
          return 'Doctor'
        case 'Bookkeeper':
          return 'Finance'
        default:
          return role
      }
    },
    getSizeText (size) {
      let selectedSize = this.sizes?.find(f => f.value === size)
      if (selectedSize) {
        return selectedSize.text
      }
      return '-'
    },
    getScrollbarWidth() {
      // Create a temporary div element
      const div = document.createElement('div')

      // Apply styles to force a scrollbar
      div.style.position = 'absolute'
      div.style.top = '-9999px' // Move it off-screen
      div.style.width = '100px'
      div.style.height = '100px'
      div.style.overflow = 'scroll'

      // Append the element to the body
      document.body.appendChild(div)

      // Calculate the scrollbar width
      const scrollbarWidth = div.offsetWidth - div.clientWidth

      // Remove the temporary element
      document.body.removeChild(div)

      this.$store.commit('ui/setScrollbarWidth', scrollbarWidth)
    },
    redirectTo (route) {
      this.$router.push(route).catch(()=>{})
    },
    logoutUrl () {
      let link = '/signout'
      if (this.member.username) {
        link += '?username=true'
      }
      return link
    },
    isMenuActive (menuTab) {
      const currentPath = this.$route.path
      if (menuTab.id === 'inventory') {
        return currentPath.startsWith(menuTab.to) && !currentPath.startsWith('/admin/hq/inventory/settings')
      }
      return currentPath.startsWith(menuTab.to)
    },
    changeCompanyUrl () {
      return '/companies'
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-active {
  height: 2px;
  width: 24px;
  margin: auto;
  margin-top: -2px;
  background-color: #333;
}
</style>
